var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTinyLeft = function SvgArrowTinyLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 6A5.5 5.5 0 0 1 6 .5h8A5.5 5.5 0 0 1 19.5 6v8a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 14V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6E5F2",
    d: "M.5 6A5.5 5.5 0 0 1 6 .5h8A5.5 5.5 0 0 1 19.5 6v8a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 14V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B2C9DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "m12 14-4-4 4-4"
  }))));
};
export default SvgArrowTinyLeft;